import { dropdownValidator } from '../fields';

export const qboIntegrationConstraints = (
  isBidirectionalSyncEnabled,
  validateAccountInfo
) => ({
  ...(validateAccountInfo && {
    account: dropdownValidator({ mandatory: true })
  }),
  ...(isBidirectionalSyncEnabled && {
    incomeAccountMappingForNonInventoryItems: dropdownValidator({
      mandatory: true
    }),
    incomeAccountMappingForServiceItems: dropdownValidator({ mandatory: true })
  })
});
